/// <reference types="bootstrap"/>
import BootstrapBackdrop from 'bootstrap/js/dist/util/backdrop';
class Backdrop {
    constructor(config) {
        this.config = config;
        this.instance = this.createInstance();
    }
    createInstance() {
        return new BootstrapBackdrop({});
    }
    show() {
        this.instance.show();
    }
    hide() {
        this.instance.hide();
    }
}
export { Backdrop };
